export default "/static/assets/apple-touch-icon.b042fd6aae9d723a7c599594b9f03bd8.png";